(function () {
  const config = window.__themeConfig;
  if (!config) return;

  window.Theme = {
    routes: config.routes,
    translations: config.translations,
    placeholders: config.placeholders,
    template: config.template,
    designMode: config.designMode,
  };
})();